// Shared server URL for API calls from the web app.
// Priority: REACT_APP_SERVER_URL | EXPO_PUBLIC_SERVER_URL | tenant subdomain → root host | same-origin | (local CRA only) http://localhost:3001
// Do not silently use localhost for API in non–local-dev builds: missing config surfaces a UI error (see App.js).

const fromEnv =
  typeof process !== "undefined" &&
  process.env &&
  (process.env.REACT_APP_SERVER_URL || process.env.EXPO_PUBLIC_SERVER_URL);
const fromEnvTrimmed = fromEnv && fromEnv.trim && fromEnv.trim();

const sameOrigin =
  typeof window !== "undefined" && window.location && window.location.origin;

const isLocalDev =
  typeof window !== "undefined" &&
  window.location &&
  (window.location.origin === "http://localhost:3000" ||
    window.location.origin === "http://127.0.0.1:3000" ||
    (window.location.hostname.endsWith(".localhost") && window.location.port === "3000"));

const LOCAL_API_FALLBACK = "http://localhost:3001";

function computeServerUrl() {
  if (fromEnvTrimmed || fromEnv) return String(fromEnvTrimmed || fromEnv).trim();

  if (typeof window === "undefined" || !window.location) return "";

  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const hasTenantSubdomain =
    parts.length >= 4 &&
    hostname !== "localhost" &&
    hostname !== "127.0.0.1" &&
    !hostname.endsWith(".localhost");
  if (hasTenantSubdomain) {
    const rootHost = parts.slice(1).join(".");
    const protocol = window.location.protocol || "https:";
    const port =
      window.location.port && window.location.port !== "80" && window.location.port !== "443"
        ? ":" + window.location.port
        : "";
    return `${protocol}//${rootHost}${port}`;
  }

  if (isLocalDev) return LOCAL_API_FALLBACK;

  return (sameOrigin || "").trim();
}

const SERVER_URL = computeServerUrl();

export function isServerApiUrlConfigured() {
  return Boolean(SERVER_URL && String(SERVER_URL).trim());
}

/** Non-empty when the app cannot call the API until env / deployment is fixed. */
export function getServerConfigurationErrorMessage() {
  if (isServerApiUrlConfigured()) return "";
  return (
    "Missing API server URL. This app is not configured to reach the backend. " +
    "Set REACT_APP_SERVER_URL in your environment when you build or start the web app " +
    "(for example in web-app/.env), or deploy so the API is on the same host as this page " +
    "(same-origin). For local development, run the web app from http://localhost:3000 so the default API port can be used."
  );
}

export const serverInfo = {
  serverUrl: SERVER_URL,
};

const serverConfig = { serverInfo };
export default serverConfig;
